class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Hover-to-open on desktop (mouse/trackpad only). Touch and keyboard keep click/tap behaviour.
    this.hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');
    this.closeDelay = 150;
    this.closeTimeout = null;

    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.mainDetailsToggle
      .querySelector('summary')
      .addEventListener('click', this.onSummaryClick.bind(this));
  }

  onMouseEnter() {
    if (!this.hoverCapable.matches) return;
    clearTimeout(this.closeTimeout);

    // Close any other open top-level dropdown straight away
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this && menu.mainDetailsToggle && menu.mainDetailsToggle.hasAttribute('open')) {
        clearTimeout(menu.closeTimeout);
        menu.close();
      }
    });

    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    }
  }

  onMouseLeave() {
    if (!this.hoverCapable.matches) return;
    clearTimeout(this.closeTimeout);
    this.closeTimeout = setTimeout(() => this.close(), this.closeDelay);
  }

  onSummaryClick(event) {
    // Let clicks on the top-level label link navigate as normal
    if (event.target.closest('a')) return;

    // With hover active, a mouse click on an already-open header shouldn't snap it shut.
    // event.detail is 0 for keyboard-triggered clicks, so Enter/Space still toggle as normal.
    if (this.hoverCapable.matches && event.detail > 0 && this.mainDetailsToggle.hasAttribute('open')) {
      event.preventDefault();
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);